import request from "../utils/request";

export function getComplaints(query) {
  const params = {
    page: query && query.page != null ? query.page : 1,
    "sort-by": query && query.sortBy != null ? query.sortBy : undefined,
    "sort-desc": query && query.sortDesc != null ? query.sortDesc : undefined,
    size: query && query.size != null ? query.size : 15,
  };

  // Add filter as JSON string if filters exist
  if (query && query.filter) {
    const filterObj = {};

    // Add text filter if it exists
    if (query.filter.text) {
      filterObj.text = query.filter.text;
    }

    // Add status filter if it exists (including 0 which is a valid status)
    if (
      query.filter.status !== undefined &&
      query.filter.status !== null &&
      query.filter.status !== ""
    ) {
      filterObj.status = query.filter.status;
    }

    // Optional committee membership flag
    if (query.filter.onlyMyCommittee === true) {
      filterObj.onlyMyCommittee = true;
    }

    // Add companyId filter if it exists
    if (
      query.filter.companyId !== undefined &&
      query.filter.companyId !== null
    ) {
      filterObj.companyId = query.filter.companyId;
    }

    // Add date range filters if they exist
    if (query.filter.startDate) {
      filterObj.startDate = query.filter.startDate;
    }
    if (query.filter.endDate) {
      filterObj.endDate = query.filter.endDate;
    }

    // Only add filter param if we have actual filters
    if (Object.keys(filterObj).length > 0) {
      params.filter = JSON.stringify(filterObj);
    }
  }

  return request({
    url: "/complaints",
    method: "get",
    params,
  });
}

export function getComplaint(id) {
  return request({
    url: `/complaints/${id}`,
    method: "get",
  });
}

export function findComplaintIdByProtocol(protocol) {
  return request({
    url: `/complaints/find/${protocol}`,
    method: "get",
  });
}

export function resendTask(id, evendId) {
  return request({
    url: `/complaints/${id}/events/${evendId}/resend`,
    method: "post",
  });
}

export function updateCommittee(id, committee) {
  return request({
    url: `/complaints/${id}/committee`,
    method: "put",
    data: committee,
  });
}

export function revokeCommitteeAccess(id) {
  return request({
    url: `/complaints/${id}/committee`,
    method: "delete",
  });
}

export function createEvent(id, data) {
  return request({
    url: `/complaints/${id}/events`,
    method: "post",
    data,
  });
}

export function getEvents(id) {
  return request({
    url: `/complaints/${id}/events`,
    method: "get",
  });
}

export function associatePhoneServiceProtocol(id, protocol, date) {
  return request({
    url: `/complaints/${id}/associatePhoneServiceProtocol`,
    method: "post",
    data: {
      protocol,
      date,
    },
  });
}

export function createMonitoring(id, data) {
  return request({
    url: `/complaints/${id}/monitoring`,
    method: "post",
    data,
  });
}

export function getMonitoring(id) {
  return request({
    url: `/complaints/${id}/monitoring`,
    method: "get",
  });
}

export function setMonitoringVisibility(monitoring, hidden) {
  return request({
    url: `/complaints/${monitoring.complaint}/monitoring/${monitoring._id}`,
    method: "post",
    data: {
      hidden,
    },
  });
}

export function setMonitoringResponseEnabled(complaint, enabled) {
  return request({
    url: `/complaints/${complaint._id}/monitoring-response`,
    method: "post",
    data: {
      enabled,
    },
  });
}

export function classifyComplaint(id, data) {
  return request({
    url: `/complaints/${id}/classification`,
    method: "patch",
    data,
  });
}

export function addDenounced(id, data) {
  return request({
    url: `/complaints/${id}/denounced`,
    method: "post",
    data,
  });
}

export function getDenounceds(id) {
  return request({
    url: `/complaints/${id}/denounced`,
    method: "get",
  });
}

export function removeDenounced(complaintId, denouncedId, justification) {
  return request({
    url: `/complaints/${complaintId}/denounced/${denouncedId}`,
    method: "delete",
    data: { justification },
  });
}

export function setEventIrrelevant(
  complaintId,
  eventId,
  marked,
  justification
) {
  return request({
    url: `/complaints/${complaintId}/events/${eventId}/irrelevant`,
    method: "patch",
    data: { marked, justification },
  });
}

export function generateAISummary(complaintId) {
  return request({
    url: `/complaints/${complaintId}/generate-summary`,
    method: "post",
  });
}

export function verifyCourseStatus(complaintId, eventId) {
  return request({
    url: `/complaints/${complaintId}/events/${eventId}/verify-course-status`,
    method: "post",
  });
}
